import { ToastContainer } from "react-toastify";
import "./App.css";
import AppRoutes from "./routes/routes";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchOfficeDetails } from "./redux/homeSlice";
import { AppDispatch } from "./redux/store";

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchOfficeDetails());
  }, [dispatch]);

  return (
    <>
      <ToastContainer />
      <AppRoutes />
    </>
  );
}

export default App;